import { Component, Input } from '@angular/core';
import { UnrelatedDeviceForm } from '../../forms/unrelated-device.form';
import { CommonModule, NgIf } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';
import { DatePickerComponent } from '../../../../../../../common/date-picker/date-picker.component';

@Component({
  selector: 'app-unrelated-device-form',
  standalone: true,
  imports: [
    CommonModule,
    NgxMaskDirective,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    DatePickerComponent
  ],
  templateUrl: './unrelated-device-form.component.html'
})
export class UnrelatedDeviceFormComponent {

  @Input()
  public form: UnrelatedDeviceForm | undefined;

  constructor() {
  }
}
